var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "my-bookmark__list" },
    _vm._l(_vm.postList, function(post) {
      return _c("bookmark-item", {
        attrs: { post: post, bookmark: _vm.bookmark },
        on: { delete: _vm.onBookmarkDelete }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }